// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3q9je","header":"MessagesList_header__1zIrC","chat":"MessagesList_chat__2KNAI"};